<template>
  <div class="error-page-wrap" data-test="viewpoints-required-error-page">
    <img
      src="../../assets/chameleon-magnifying-glass.png"
      style="
        width: 50%;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
        max-width: 300px;
      "
      alt="forbidden"
    />
    <h2 style="text-align: center">Sorry! You don't yet have a Viewpoints report.</h2>
    <!-- <h3>You don't yet have a Viewpoints report.</h3> -->
    <h3>
      Create one by following
      <a href="/my/pathway/viewpoints-invite">this link</a> and inviting people to review you. Once
      you have feedback from at least two people, your Viewpoints report will be unlocked.
    </h3>
    <div
      style="margin-top: 30px; display: flex; justify-content: center"
      data-test="viewpoints-required-error-page"
    >
      <a
        class="btn btn-default-back"
        onclick="window.history.back()"
        href="#"
        data-test="viewpoints-required-back-button"
      >
        Back
      </a>
    </div>
  </div>
</template>

<style lang="less" scoped>
.error-page-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 60%;
  text-align: center;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 10px;
    img {
      width: 80%;
    }
  }
}
</style>
